import React from 'react';
import IntlMessage from "../../../components/IntlMessage/IntlMessage";

const MonthString = ({month}) => {
    if (month === 1) {
        return <IntlMessage id={'month.1'}/>;
    } else if (month === 2) {
        return <IntlMessage id={'month.2'}/>;
    } else if (month === 3) {
        return <IntlMessage id={'month.3'}/>;
    } else if (month === 4) {
        return <IntlMessage id={'month.4'}/>;
    } else if (month === 5) {
        return <IntlMessage id={'month.5'}/>;
    } else if (month === 6) {
        return <IntlMessage id={'month.6'}/>;
    } else if (month === 7) {
        return <IntlMessage id={'month.7'}/>;
    } else if (month === 8) {
        return <IntlMessage id={'month.8'}/>;
    } else if (month === 9) {
        return <IntlMessage id={'month.9'}/>;
    } else if (month === 10) {
        return <IntlMessage id={'month.10'}/>;
    } else if (month === 11) {
        return <IntlMessage id={'month.11'}/>;
    } else if (month === 12) {
        return <IntlMessage id={'month.12'}/>;
    } else {
        return null;
    }
}

export default MonthString;